<template>
  <VAppBar :height="height" :elevation="elevation">
    <slot name="prepend" />
    <slot />
    <slot name="append" />
  </VAppBar>
</template>

<script setup lang="ts">
import { VAppBar } from 'vuetify/components/VAppBar';

export interface Props {
  height?: number;
  elevation?: number;
}

withDefaults(defineProps<Props>(), {
  height: 64,
  elevation: 0,
});
</script>
